import React from 'react';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import HeaderLogo from '../AppLogo';
import UserBox from './Components/UserBox';

const Header = () => {
  const themeOption = useSelector(state => state.themeOption);
  const { headerBackgroundColor, enableMobileMenuSmall, enableHeaderShadow } =
    themeOption;

  return (
    <>
      <TransitionGroup>
        <CSSTransition
          component="div"
          className={cx('app-header', headerBackgroundColor, {
            'header-shadow': enableHeaderShadow,
          })}
          appear
          timeout={1500}
          enter={false}
          exit={false}
        >
          <div>
            <HeaderLogo />
            <div
              className={cx('app-header__content', {
                'header-mobile-open': enableMobileMenuSmall,
              })}
            >
              <div className="app-header-right w-100">
                <UserBox />
              </div>
            </div>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </>
  );
};

export default Header;
